import React, { ChangeEvent, KeyboardEvent, useState } from "react";
import CloseSvg from "../../assets/taiga-uikit/icons/close.svg?react";
import { _size, _style, _typeInput } from "../../core/core";
import { Button } from "../button/button";
import "./Input.css";
import "./InputChat.css";

interface InputChatProps {
  size?: _size;
  type?: _typeInput;
  label?: string;
  placeholder?: string;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  value?: string;
  setValue?: (value: string) => void;
  focusStart?: boolean;
  onBlurHandel?: () => void;
}

export const InputChat: React.FC<InputChatProps> = ({
  size = _size.M,
  type = _typeInput.text,
  label,
  placeholder,
  onKeyDown,
  value = "",
  setValue,
  focusStart = false,
  onBlurHandel,
}) => {
  const [focus, setFocus] = useState<boolean>(focusStart);

  const variantsClassName = (): string => {
    return `input-field input-field-${size} input-chat`;
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setValue?.(event.target.value);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
    onKeyDown?.(event);
  };

  const onClickClear = (): void => {
    setValue?.("");
    setFocus(true);
  };

  return (
    <div className="field">
      <div className={variantsClassName()}>
        <div className="field-content">
          <input
            type={type}
            value={value}
            placeholder={placeholder || label || ""}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onBlur={onBlurHandel}
            autoFocus={focus}
          />
        </div>
        {value && (
          <Button
            style={_style.clear}
            icon_right={<CloseSvg />}
            onClick={onClickClear}
          />
        )}
      </div>
    </div>
  );
};
